import { render, staticRenderFns } from "./AxxessLtePackagePrices.vue?vue&type=template&id=f954f75e&scoped=true&"
import script from "./AxxessLtePackagePrices.vue?vue&type=script&lang=js&"
export * from "./AxxessLtePackagePrices.vue?vue&type=script&lang=js&"
import style0 from "./AxxessLtePackagePrices.vue?vue&type=style&index=0&id=f954f75e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f954f75e",
  null
  
)

export default component.exports